// extracted by mini-css-extract-plugin
module.exports = {"supportFaqs":"support-faqs_supportFaqs__9R04A"};